export const update_user_password_with_confirm = `mutation update_user_password_with_confirm($input: UpdateUserPassword!){
    update_user_password_with_confirm(input: $input){
        token
    }
}`;
